import { render, staticRenderFns } from "./DataSendPurchase.vue?vue&type=template&id=5302d890&"
import script from "./DataSendPurchase.vue?vue&type=script&lang=ts&"
export * from "./DataSendPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports